import { OnlyPublicApiPaths } from '@hefe/auth';
import { t } from '@hefe/i18n';
import { userState } from '@hefe/store';
import { PropsWithChildren, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { matchRoutes, useLocation, useNavigate } from 'react-router-dom';
import routes from '../../routes/routes';
import LoadingPage from '../../views/base/loading/loading.page';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface AuthorizationProviderProps {}

function AuthorizationProvider(
  props: PropsWithChildren<AuthorizationProviderProps>
) {
  const [hasAuthChecked, setAuthChecked] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const user = useSelector(userState).user;

  useEffect(() => {
    checkAuth();
  }, [location.pathname]);

  const checkAuth = () => {
    setAuthChecked(false);

    let matched: any;
    const matchedRoutes = matchRoutes(routes, location.pathname);
    if (matchedRoutes !== null) {
      matched = matchedRoutes[0];
    }

    let pathIsPublic = false;
    let pathIsOnlyPublic = false;
    routes.forEach((route) => {
      if (location.pathname.includes(route.pathIncludes || route.path)) {
        if (route.auth.includes('guest')) {
          if (OnlyPublicApiPaths.includes(route.pathIncludes || route.path)) {
            pathIsOnlyPublic = true;
          }

          pathIsPublic = true;
        }
      }
    });

    if (pathIsPublic) {
      if (pathIsOnlyPublic && user) {
        navigate('/');
      } else {
        if (location.pathname === '/login') {
          navigate(location.pathname, {
            state: { redirectUrl: location?.state?.redirectUrl },
          });
        } else {
          navigate(location.pathname);
        }
      }
    } else {
      if (user) {
        if (user.basketball_user === null) {
          navigate('login', {
            state: { redirectUrl: location.pathname },
          });
        } else {
          /*
           *   User has basketball user active
           */
          if (matched && matched.route.auth && matched.route.auth.length > 0) {
            const inArray = user?.role.some((r) =>
              matched.route.auth.includes(r)
            );
            if (!inArray) {
              navigate('/');
            }
          } else {
            navigate('/');
          }
        }
      } else {
        /*
         *   No user provided - send to login
         */
        navigate('login', {
          state: { redirectUrl: location.pathname },
        });
      }
    }

    /*
    if (!user || user?.basketball_user === null) {
      navigate('login', {
        state: { redirectUrl: location.pathname },
      });
    }
    
    if (matched && matched.route.auth && matched.route.auth.length > 0) {
      const inArray = user?.role.some((r) => matched.route.auth.includes(r));
      // if (!matched.route.auth.includes(this.props.user.role)) {
      if (!inArray) {
        if (!user || user?.role[0] === 'guest') {
          navigate('login', {
            state: { redirectUrl: location.pathname },
          });
        } else {
          navigate(mainPath);
        }
      }
    } else if (location.pathname === '/' && user?.role[0] === 'guest') {
      if (user?.role[0] === 'guest') {
        navigate('/login', {
          state: { redirectUrl: location.pathname },
        });
      } else {
        navigate(mainPath);
      }
    }
    */

    setAuthChecked(true);
  };

  if (hasAuthChecked) {
    return <>{props.children}</>;
  } else {
    return <LoadingPage text={t('loading.title')} />;
  }
}

export default AuthorizationProvider;
